module.exports = __webpack_public_path__ + "img/circle-notch.8634484f.png";